/* eslint-disable require-jsdoc */
import PropTypes from 'prop-types';
import React from 'react';

export function serializeStructuredData(data) {
    return JSON.stringify(data)
        .replace(/</g, '\\u003c')
        .replace(/>/g, '\\u003e')
        .replace(/&/g, '\\u0026')
        .replace(/\u2028/g, '\\u2028')
        .replace(/\u2029/g, '\\u2029');
}

const StructuredData = ({ data }) => (
    <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: serializeStructuredData(data) }}
    />
);

StructuredData.propTypes = {
    data: PropTypes.object.isRequired
};

export default StructuredData;
